import { contentAreaIds, categoryTypes } from '../config'
import { trackLhnCategorySelect } from './TaggingSerializer'

class ContentHelper {
  static getSeoArea(response) {
    if (response && response[0]) {
      if (response[0].id === contentAreaIds.SeoArea) return [response[0]]

      const i = response.findIndex(area => area.id === contentAreaIds.SeoArea)
      return [response[i]]
    }
    return []
  }

  static getSeoMeta(seoData = []) {
    return seoData && seoData[0]?.meta ? seoData[0].meta : {}
  }

  static getSeoRobotMeta(seoData = []) {
    return seoData.length && seoData[0] !== undefined && seoData[0].robotMetaData
      ? seoData[0].robotMetaData
      : {
          maxFiltersPerFacet: '#',
          maxFilteredFacets: '#'
        }
  }

  static getContentData(response) {
    return response ? response.filter(area => area.id !== contentAreaIds.SeoArea) : []
  }

  static getBrowseListerType(isPlp, isPlpPlus, isPlpPlusDescendant) {
    if (isPlp) {
      return categoryTypes.PLP
    }
    if (isPlpPlus || isPlpPlusDescendant) {
      return categoryTypes.PLPPLUS
    }
  }

  static onFindabilityClick(e, linkUrl, type = '') {
    if (!linkUrl) return
    const pathArray = linkUrl.split('/')
    const arrayLength = pathArray.length
    const categoryName = pathArray[arrayLength - 3]
    const categoryID = pathArray[arrayLength - 2].split(':')[1]
    const searchAbsoluteRegex = /(?:argos.co.uk|deveng.io)\/search\//
    const searchRelativePath = '/search/'
    const browseAbsoluteRegex = /(?:argos.co.uk|deveng.io)\/browse\//
    const browseRelativePath = '/browse/'
    if (type) {
      trackLhnCategorySelect(categoryName, categoryID)
    }
    let ajaxLinkUrl
    if (linkUrl.indexOf(searchRelativePath) === 0 || linkUrl.indexOf(browseRelativePath) === 0) {
      ajaxLinkUrl = linkUrl
    } else if (linkUrl.match(searchAbsoluteRegex)) {
      ajaxLinkUrl = searchRelativePath + linkUrl.split(searchRelativePath).pop()
    } else if (linkUrl.match(browseAbsoluteRegex)) {
      ajaxLinkUrl = browseRelativePath + linkUrl.split(browseRelativePath).pop()
    }

    if (ajaxLinkUrl) {
      e.preventDefault()
      // this.context functions are declared in Application.jsx. If you know how to improve this, be my guest
      if (this.context.updateDestinationPageType) this.context.updateDestinationPageType({ type })
      this.context.loadingStart()
      this.context.navigateTo(ajaxLinkUrl)
    }
  }
}

export default ContentHelper
